import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Rect } from '../IconBase/IconBase'
function UnCheckedRect({ color = 'white', ...props }) {
  return (
    <IconBase viewBox='0 0 34 34' {...props}>
      <Rect width='34' height='34' rx='4' fill={color} />
    </IconBase>
  )
}
UnCheckedRect.propTypes = {
  color: PropTypes.string,
}
export default UnCheckedRect
